import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";

import { RequireAuth } from "@/components/auth/RequireAuth";
import { DashboardPage } from "@/pages/DashboardPage";
import { DocsPage } from "@/pages/DocsPage";
import { InvitePage } from "@/pages/InvitePage";
import { LandingPage } from "@/pages/LandingPage";
import { LoginPage } from "@/pages/LoginPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { PrivacyPage } from "@/pages/PrivacyPage";
import { RegisterPage } from "@/pages/RegisterPage";
import { RoomsPage } from "@/pages/RoomsPage";
import { PageSpinner } from "@/components/ui/Spinner";
import { useT } from "@/lib/i18n";
import { SettingsPage } from "@/pages/SettingsPage";

const RoomPage = lazy(async () => ({ default: (await import("@/pages/RoomPage")).RoomPage }));

const PlaybackPage = lazy(async () => ({
  default: (await import("@/pages/PlaybackPage")).PlaybackPage,
}));

export function AppRoutes() {
  const t = useT();
  return (
    <Routes>
      <Route element={<LandingPage />} path="/" />
      <Route element={<LoginPage />} path="/login" />
      <Route element={<RegisterPage />} path="/register" />
      <Route element={<InvitePage />} path="/invite/:token" />
      <Route element={<DocsPage />} path="/docs" />
      <Route element={<PrivacyPage />} path="/privacy" />
      {}
      <Route
        element={
          <Suspense fallback={<PageSpinner label={t("common.loading")} />}>
            <PlaybackPage />
          </Suspense>
        }
        path="/playback/:slug/:id"
      />

      <Route
        element={
          <RequireAuth>
            <DashboardPage />
          </RequireAuth>
        }
        path="/dashboard"
      />
      <Route
        element={
          <RequireAuth>
            <RoomsPage />
          </RequireAuth>
        }
        path="/rooms"
      />
      <Route
        element={
          <RequireAuth>
            <SettingsPage />
          </RequireAuth>
        }
        path="/settings"
      />

      <Route
        element={
          <Suspense fallback={<PageSpinner label={t("call.joining")} />}>
            <RoomPage />
          </Suspense>
        }
        path="/:slug"
      />
      <Route element={<NotFoundPage />} path="*" />
    </Routes>
  );
}
